import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const ArrowDownRight: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'm7 7 10 10' }],
    ['path', { d: 'M17 7v10H7' }],
  ],
];

export default ArrowDownRight;
